import { Typography } from "./Typography.js";
import { Text } from "./Text.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Typography/Heading.tsx
/**
* A heading component.
*/
var Heading = ({ as = "h1", children, ...props }) => {
	return /* @__PURE__ */ jsx(Typography, {
		as,
		type: "heading",
		...props,
		children
	});
};
/**
* A Heading level-1 styled component. Underlying HTML element can be changed
* usign the `as` property.
*/
var H1 = ({ children, ...props }) => {
	return /* @__PURE__ */ jsx(Heading, {
		as: "h1",
		weight: "semibold",
		size: "xl",
		...props,
		children
	});
};
/**
* A Heading level-2 styled component. Underlying HTML element can be changed
* usign the `as` property.
*/
var H2 = ({ children, ...props }) => {
	return /* @__PURE__ */ jsx(Heading, {
		as: "h2",
		weight: "semibold",
		size: "lg",
		...props,
		children
	});
};
/**
* A Heading level-3 styled component. Underlying HTML element can be changed
* usign the `as` property.
*/
var H3 = ({ children, ...props }) => {
	return /* @__PURE__ */ jsx(Heading, {
		as: "h3",
		weight: "semibold",
		size: "md",
		...props,
		children
	});
};
/**
* A Heading level-4 styled component. Underlying HTML element can be changed
* usign the `as` property.
*/
var H4 = ({ children, ...props }) => {
	return /* @__PURE__ */ jsx(Heading, {
		as: "h4",
		weight: "semibold",
		size: "sm",
		...props,
		children
	});
};
/**
* A Heading level-5 styled component. Underlying HTML element can be changed
* usign the `as` property.
*/
var H5 = ({ children, ...props }) => {
	return /* @__PURE__ */ jsx(Text, {
		as: "h5",
		weight: "semibold",
		size: "lg",
		...props,
		children
	});
};
/**
* A Heading level-6 styled component. Underlying HTML element can be changed
* usign the `as` property.
*/
var H6 = ({ children, ...props }) => {
	return /* @__PURE__ */ jsx(Text, {
		as: "h6",
		weight: "semibold",
		size: "md",
		...props,
		children
	});
};
//#endregion
export { H1, H2, H3, H4, H5, H6, Heading };

//# sourceMappingURL=Heading.js.map